import styled from 'styled-components';

const CommentsContent = styled.div`
  @media (max-width: 768px) {
    padding: 0 20px 20px;
    flex: 1;
    margin-top: 100px; /* Increase from 80px to 100px to provide more space below the back button */
  }
`;

export default CommentsContent; 